import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../../Common/DataTable/DataTable";
import {
  DELETE_RESTAURANT_VARIANT_REQUEST,
  GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
} from "../../../../../Utils/Constant";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { restaurantVariantColumns } from "./RestaurantVariantColumns";
import { useNavigate } from "react-router-dom";
import ConfirmationATM from "../../../../../Common/ConfirmationATM";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import {
  hasDeleteAccess,
  hasEditAccess,
} from "../../../../../Common/CheckAccess";

const RestaurantVariantTable = ({ setSelectedVariant, subCategoryId }) => {
  const dispatch = useDispatch();

  const [categoryData, setCategoryData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("name");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();

  const {
    loading,
    addCategory,
    updateCategory,
    varientList,
    updateVarient,
    addVarient,
    deleteVarient,
  } = useSelector((state) => state.restaurant);

  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  useEffect(() => {
    dispatch({
      type: GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
      payload: {
        body: { page, limit: pageSize, sortBy, sortOrder, name: globalFilter },
        subcategory_id: subCategoryId,
      },
    });
  }, [
    dispatch,
    page,
    pageSize,
    sortBy,
    sortOrder,
    addCategory,
    updateCategory,
    updateVarient,
    addVarient,
    deleteVarient,
    globalFilter,
  ]);
  const handleDelete = (selectData) => {
    setSelectedUser(selectData);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (varientList?.data?.variants?.length) {
      const transformed = varientList?.data?.variants?.map((data) => ({
        name: data?.name || "-",
        flavor: data?.flavor || "-",
        size: data?.size || "-",
        // quantity: data.quantity || "0",
        price: `₹${data?.price || "-"}`,
        created_at: data?.created_at?.split("T")[0] || "N/A",
        // category: data?.category?.name,
        sub_Category: data?.subcategory?.name,
        actions: (
          <>
            {hasDeleteAccess(permissions, "restaurant") && <button
              className="btn"
              data-toggle="modal"
              data-target="#deleteGuest"
              onClick={() => handleDelete(data)}
            >
              <i className="bi bi-trash text-danger"></i>
            </button>}
            <button
              data-bs-toggle="offcanvas"
              data-bs-target="#add-varient"
              aria-controls="add-varient"
              className="btn"
              disabled={!hasEditAccess(permissions, "restaurant")}
              onClick={() => setSelectedVariant(data)}
            >
              <i className="bi bi-pencil text-primary"></i>
            </button>
          </>
        ),
      }));

      setCategoryData(transformed);
    } else {
      setCategoryData([]);
    }
  }, [openMenuId, varientList]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const confirmDelete = () => {
    dispatch({
      type: DELETE_RESTAURANT_VARIANT_REQUEST,
      payload: { id: selectedUser?.id },
    });
    setShowDeleteModal(false);
  };

  // Extract total entries and total pages from API pagination info
  const totalEntries = varientList?.data?.pagination?.totalResults || 0;
  const totalPages = varientList?.data?.pagination?.totalPages || 1;

  return (
    <div>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="dish"
      />
      <DataTable
        columns={restaurantVariantColumns}
        data={categoryData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      <ConfirmationATM
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedUser("");
        }}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete ${selectedUser?.name} ?`}
      />
    </div>
  );
};

export default RestaurantVariantTable;
